import { render, staticRenderFns } from "./editClue.vue?vue&type=template&id=40bf2fc8&scoped=true"
import script from "./editClue.vue?vue&type=script&lang=js"
export * from "./editClue.vue?vue&type=script&lang=js"
import style0 from "./editClue.vue?vue&type=style&index=0&id=40bf2fc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bf2fc8",
  null
  
)

export default component.exports